import React from 'react';
import { Provider } from 'react-redux';
import LocationDashboard from './LocationDashboard';

export default () => (
  <Provider store={ReactOnRails.getStore('appStore')}>
    <LocationDashboard />
  </Provider>
);
